import axios from "axios"
import Auth from "@/auth/auth-token"

class Rules {
  constructor() {
    const base = axios.create({
      baseURL: process.env.VUE_APP_RULES_MANAGEMENT_API,
      withCredentials: false,
      headers: {
        "Content-Type": "application/json",
      }
    })
    this.rules = base
  }

  async addDefaultRules(party_id) {
    await Auth.setAuth(this.rules, {
      audience: process.env.VUE_APP_TPR_AUDIENCE
    })
    return this.rules({
      url: `/rulesets/default/${party_id}`,
      method: 'POST'
    })
  }
}

export default new Rules()